(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const menu = document.getElementById('MenuDrawer');
    const search = document.getElementById('SearchDialog');
    const menuOpen = document.querySelector('[data-menu-open]');
    const menuClose = document.querySelector('[data-menu-close]');
    const searchOpen = document.querySelector('[data-search-open]');
    const searchClose = document.querySelector('[data-search-close]');

    const setExpanded = (button, open) => {
      if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const closeOnBackdrop = (dialog) => {
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    };

    menuOpen?.addEventListener('click', () => {
      menu?.showModal();
      setExpanded(menuOpen, true);
    });
    menuClose?.addEventListener('click', () => {
      menu?.close();
      setExpanded(menuOpen, false);
    });
    menu?.addEventListener('close', () => setExpanded(menuOpen, false));
    closeOnBackdrop(menu);

    searchOpen?.addEventListener('click', () => {
      search?.showModal();
      setExpanded(searchOpen, true);
      search?.querySelector('input')?.focus();
    });
    searchClose?.addEventListener('click', () => {
      search?.close();
      setExpanded(searchOpen, false);
    });
    search?.addEventListener('close', () => setExpanded(searchOpen, false));
    closeOnBackdrop(search);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const form = document.querySelector('.product-form');
    if (!form) return;
    const input = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Number(input.value || 1) + Number(button.dataset.qty);
        input.value = Math.max(1, next);
      });
    });

    const variantSelect = form.querySelector('select[name="id"]');
    const skuRow = document.querySelector('[data-sku-row]');
    const skuValue = document.querySelector('[data-sku-value]');
    variantSelect?.addEventListener('change', () => {
      if (!skuRow || !skuValue) return;
      const selected = variantSelect.selectedOptions[0];
      const sku = selected?.dataset.sku || '';
      skuValue.textContent = sku;
      skuRow.hidden = sku.trim() === '';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
